module.exports = __webpack_public_path__ + "img/chart_opacity_bg.ef3f039f.png";